//C:\Users\Anish\xpr_survey\XPRSuvey-App\src\Components\Survey\Services\SurveyService.js
import api from "../../axios";

export const createSurvey = async (surveyName, surveyDescription, image) => {
  const formData = new FormData();

  formData.append("SurveyName", surveyName);
  formData.append("SurveyDescription", surveyDescription);

  if (image) {
    formData.append("Image", image);
  }

  return api.post(
    "/api/XPRS_Survey/XPRSSurvey/CreateSurvey",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const createSurveyQuestions = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/ManageSurveyQuestions", payload);
};

export const getSurveyDetails = () => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/SurveyDetails");
}

export const getSurveyData = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/SurveyData", payload);
};

export const getSurveyQuestions = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/SurveyQuestions", payload);
};

export const publishAssessment = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/PublishAssessment", payload);
};

export const CreateResponders = (assessmentUID, excelFile, deadline) => {
  const formData = new FormData();

  formData.append("AssessmentUID", assessmentUID);
  formData.append("Excel", excelFile);
  formData.append("Deadline", deadline);

  return api.post("/api/XPRS_Survey/XPRSSurvey/CreateResponders", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const CreateSingleResponder = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/CreateResponder", payload);
};

export const GetSurevyResponders = (assessmentUID) => {
  return api.get(`/api/XPRS_Survey/XPRSSurvey/SurveyResponders/${assessmentUID}`);
};

export const GetAssessmentReportDetails = () => {
  return api.post(`/api/XPRS_Survey/XPRSSurvey/GetReportSurveyDetails`);
};

export const GetExcelReport = (assessmentID, responderUID) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/ExcelReportRequest", { AssessmentID: assessmentID, ResponderUID: responderUID },
    { responseType: "blob" }
  );
};

export const GetBulkExcelReport = (responderKeys) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/GetBulkExcelReport", { ResponderKeys: responderKeys },
    { responseType: "blob" }
  );
};

export const updateSurvey = (surveyUID, surveyName, surveyDescription, image) => {
  const formData = new FormData();

  formData.append("SurveyUID", surveyUID);
  formData.append("SurveyName", surveyName);
  formData.append("SurveyDescription", surveyDescription);

  // Only append if a new file was selected — omitting it keeps the existing image on the backend
  if (image) {
    formData.append("Image", image);
  }

  return api.post(
    "/api/XPRS_Survey/XPRSSurvey/EditSurvey", // was pointing to a non-existent /UpdateSurvey route
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const deleteSurvey = (surveyUID) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/DeleteSurvey", {
    SurveyUID: surveyUID,
  });
};

export const duplicateSurvey = (surveyUID) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/DuplicateAssessment", {
    SurveyUID: surveyUID,
  });
};

export const AddUserAPI = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/AddUser", payload);
};

export const UpdateUserAPI = (payload) => api.post("/api/XPRS_Survey/XPRSSurvey/AddUser", payload);

export const GetAllUsers = () => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/GetAllUsers");
};

export const GetAllCompanyHR = (AssessmentUID) => {
  return api.post(`/api/XPRS_Survey/XPRSSurvey/GetAllCompanyHR/${AssessmentUID}`);
};


export const GetUserAssessmentDetails = () => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/GetAllUsers");
};

export const AssignUserAssessment = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/AssignUserAssessment", payload);
};

export const UnassignUserAssessment = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/UnassignAssessment", payload);
};

export const GetAssignedUsersByAssessmentUID = (assessmentUID) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/GetAssignedUsersByAssessmentUID", null, { params: { AssessmentUID: assessmentUID } } // backend reads this via [FromQuery]
  );
};

export const GetAssignedAssessmentList = (userUID) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/GetAssignedAssessmentList", null, { params: { UserUID: userUID }, });
};

export const createAssessmentTemplate = (payload) =>
  api.post("/api/XPRS_Survey/XPRSSurvey/CreateAssessmentTemplate", payload);

export const getAssessmentTemplates = (payload) => api.post("/api/XPRS_Survey/XPRSSurvey/GetAssessmentTemplates", payload);

export const getCompanyLogo = async () => {
  const response = await api.post(
    "/api/XPRS_Survey/XPRSSurvey/GetCompanyLogo",
    {},
    { responseType: "blob" }
  );
  return response.data; // Blob
};

export const CreateRemainders = (payload) => api.post("/api/XPRS_Survey/XPRSSurvey/CreateRemainders", payload);

export const GetRelatedCompanyUser = (assessmentUID) => {
  return api.get(`api/XPRS_Survey/XPRSSurvey/GetRelatedCompanyUser/${assessmentUID}`);
};

export const SharedAssessment = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/SharedAssessment", payload);
};

export const GetDashboardData = () => api.get("api/XPRS_Survey/XPRSSurvey/DashBoardData");

export const GetGraphDataByFilter = (month, year) => api.get("api/XPRS_Survey/XPRSSurvey/GraphDataByFilter", {
  params: {
    Month: month,
    Year: year
  }
});

export const AssignAssessmentToCompanies = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/AssigAssessmentToCompanies", payload);
};

export const UnassignAssessmentToCompany = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/UnAssigAssessmentToCompanies", payload);
};

export const GetAssignedCompaniesByAssessmentUID = (assessmentUID) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/GetAssignedCompaniesByAssessmentUID", null, { params: { AssessmentUID: assessmentUID } }
  );
};

export const UpdateResponderDetails = (payload) => {
  return api.post("api/XPRS_Survey/XPRSSurvey/UpdateResponderDetails", payload);
};

export const assignChannelToAssessment = (payload) => {
  return api.post("/api/XPRS_Survey/XPRSSurvey/AssignChannelToAssessment", payload);
}


export const GetChannelsAccordingToAssessment = (assessmentUID) => {
  return api.get(`/api/XPRS_Survey/XPRSSurvey/GetChannelsAccordingToAssessments/${assessmentUID}`);
};

export const GetCompanyAssessmentByUID = (CompanyUID) => {
  return api.post(`/api/XPRS_Survey/XPRSSurveyMasterData/GetCompanyAssessmentByUID/${CompanyUID}`);
};

export const ExpiredAssessmentAPI = (AssessmentUID) => {
  return api.post(`/api/XPRS_Survey/XPRSSurvey/ExpiredAssessment?AssessmentUID=${AssessmentUID}`);
};
